<template>
  <div>
    <div class="mainContainer">
      <!-- main stuff -->
      <div class="milestoneContainer">
        <span class="circle">
          <img class="milestoneImg" src="../assets/ribbon.svg" />
        </span>
        <h2>
          How do you feel about your progress towards accomplishing this goal
          last week?
        </h2>
        <div class="emojiContainer">
          <div class="reactionSelect">
            <img class="emojiImg" src="../assets/bad.svg" alt="" />
            <input
              class="radioInput"
              type="radio"
              value="1"
              v-model="feeling"
            />
            <h5>Bad</h5>
          </div>
          <div class="reactionSelect">
            <img class="emojiImg" src="../assets/not_good.svg" alt="" />
            <input
              class="radioInput"
              type="radio"
              v-model="feeling"
              value="2"
            />
          </div>
          <div class="reactionSelect">
            <img class="emojiImg" src="../assets/alright.svg" alt="" />
            <input
              class="radioInput"
              type="radio"
              v-model="feeling"
              value="3"
            />
          </div>
          <div class="reactionSelect">
            <img class="emojiImg" src="../assets/good.svg" alt="" />
            <input
              class="radioInput"
              type="radio"
              v-model="feeling"
              value="4"
            />
          </div>
          <div class="reactionSelect">
            <img class="emojiImg" src="../assets/great.svg" alt="" />
            <input
              class="radioInput"
              type="radio"
              v-model="feeling"
              value="5"
            />
            <h5>Great</h5>
          </div>
        </div>
      </div>
      <!-- <button @click="showModal = true">Mark your progress</button> -->
    </div>
    <ProgressModal
      v-show="showModal"
      @close="logGoal"
      @setProgress="logProgress"
    ></ProgressModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProgressModal from "./ProgressModal.vue";
export default {
  components: {
    ProgressModal,
  },
  computed: {
    ...mapGetters(["getGoalData", "getSelected"]),
  },
  data() {
    return {
      feeling: null,
      showModal: false,
      progress: null,
    };
  },
  methods: {
    ...mapActions(["setStoreGoal"]),
    logProgress(progress) {
      this.progress = progress;
    },
    logGoal() {
      const logGoalURI = `/goal/${this.getGoalData.id}/log`;
      const logData = {
        log: {
          feeling: this.feeling,
          progress: this.progress,
        },
        criterial: this.getSelected,
      };
      this.$axios
        .post(logGoalURI, logData)
        .then((result) => {
          this.setStoreGoal(result.data.data);
          console.log(result);
          this.$router.push("/dashboard");
        })
        .catch((err) => {
          // this.$router.push('/home')
          console.log(err);
        });
    },
  },
  watch: {
    feeling(val) {
      if (val) {
        this.showModal = true;
      }
    },
  },
};
</script>

<style scoped>
.mainContainer {
  width: 100vw;
}

.milestoneContainer {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.01);
  border-radius: 50px;
  padding: 2rem 4rem;
  background-repeat: no-repeat;
  background-image: linear-gradient(#ffdb1c, #ffdb1c),
    linear-gradient(#ffffff, #ffffff);
  background-size: 100% 90px, 100%;
  width: 50%;
  margin: 0 auto;
}

.circle {
  position: relative;
  margin-top: 1rem;
  height: 100px;
  width: 100px;
  background-color: #fff;
  border-radius: 50%;
  display: inline-block;
}

.milestoneImg {
  position: absolute;
  height: 50px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.radioInput {
  margin: 0 auto;
}

.emojiContainer {
  margin: 20px 0;
  display: flex;
  justify-content: space-evenly;
}

.emojiImg {
  margin-bottom: 10px;
}

.reactionSelect {
  display: flex;
  flex-direction: column;
}

.reactionSelect > h5 {
  margin-top: 10px;
  color: #d2d2d2;
}
</style>
